function _getXhr() {
    if (window.XMLHttpRequest) {
        return new XMLHttpRequest();
    } else {
        //遍历IE中不同版本的ActiveX对象
        const versions = ['Microsoft', 'msxm3', 'msxml2', 'msxml1'];
        for (let i = 0; i < versions.length; i++) {
            try {
                const version = versions[i] + '.XMLHTTP';
                return new ActiveXObject(version);
            } catch (e) {
                console.error('该浏览器不支持Ajax请求，请更新浏览器！');
            }
        }
    }
}

function _urlFormat(url, data, method) {
    if (method === 'GET') {
        url += url.indexOf('?') > -1 ? `&${data}` : `?${data}`;
    }
    return url;
}

function _dataFormat(data, method, headers = {}) {
    const contentType = headers['content-type'] || headers['Content-Type'] || '';

    if (method === 'GET' || contentType.toLowerCase() === 'application/x-www-form-urlencoded') {
        const res = [];
        Object.keys(data).forEach((key) => {
            if (data[key]) {
                if (Object.prototype.toString.call(data[key]) === '[object Object]') {
                    res.push(`${key}=${JSON.stringify(data[key])}`);
                } else {
                    res.push(`${key}=${data[key]}`);
                }
            }
        });
        return res.join('&');
    } else {
        return JSON.stringify(data);
    }
}

function _handleError({ error, config, status, statusText, responseText, responseHeaders, requestHeaders }) {
    error.requestConfig = config;
    error.httpStatus = status;
    error.statusText = statusText;
    error.responseText = responseText;
    error.responseHeaders = responseHeaders;
    error.requestHeaders = requestHeaders;

    return error;
}

function _createAjax(config) {
    return new Promise((resolve, reject) => {
        let { url, method = 'GET', data = {}, timeout, headers, async = true } = config;
        method = method.toUpperCase();
        data = _dataFormat(data, method, headers);
        url = _urlFormat(url, data, method);

        const xhr = _getXhr();
        xhr.open(method, url, async);

        //header设置
        let customContentType = false;
        if (headers) {
            for (let key in headers) {
                xhr.setRequestHeader(`${key.toString()}`, `${headers[key].toString()}`);
                if (key.toLowerCase() === 'content-type') {
                    customContentType = true;
                }
            }
        }
        if (!customContentType && method !== 'GET') {
            xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
        }
        //timeout设置
        if (timeout) {
            xhr.timeout = timeout;
            xhr.addEventListener('timeout', (e) => {
                reject(
                    _handleError({
                        error: new Error('请求超时'),
                        requestConfig: config,
                        httpStatus: 0, // 超时状态吗设置为0
                        statusText: 'Timeout',
                        responseText: null, // 没有响应文本
                        requestHeaders: headers,
                        responseHeaders: null, // 没有响应头
                    }),
                );
            });
        }

        //监听状态
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                const { status, statusText, responseText } = xhr;
                const isSuccess = (status >= 200 && status < 300) || status === 304;
                const allHeaders = xhr.getAllResponseHeaders();

                if (isSuccess) {
                    try {
                        const resJson = JSON.parse(responseText);
                        resolve({
                            requestConfig: config,
                            httpStatus: status,
                            statusText,
                            resData: resJson,
                            responseText,
                            requestHeaders: headers,
                            responseHeaders: allHeaders,
                        });
                    } catch (error) {
                        reject(
                            _handleError({
                                error,
                                config,
                                status,
                                statusText,
                                responseText,
                                requestHeaders: headers,
                                responseHeaders: allHeaders,
                            }),
                        );
                    }
                } else {
                    const error = new Error('请求失败，请检查网络或者风控');
                    reject(
                        _handleError({
                            error,
                            config,
                            status,
                            statusText,
                            responseText,
                            requestHeaders: headers,
                            responseHeaders: allHeaders,
                        }),
                    );
                }
            }
        };

        //发送数据
        xhr.send(method === 'GET' ? null : data);
    });
}

function get(config) {
    return _createAjax({
        ...config,
        method: 'GET',
    });
}

function post(config) {
    return _createAjax({
        ...config,
        method: 'POST',
    });
}

function ajax(config) {
    return _createAjax(config);
}

export { get, post, ajax };
